<template class="DangerMessage">
  <transition name="fade">
    <div class="alert alert-danger w-100 mt-3" v-if="vif" v-text="vtext"></div>
  </transition>
</template>
<script>
export default {
  name: "DangerMessage",
  components: {},
  data() {
    return {};
  },
  methods: {},
  props: {
    vif: {
      type: Boolean,
      required: true,
      default: false,
    },
    vtext: {
      required: true,
      default: "",
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
